import React, { useState } from 'react';
import { Link as RouterLink, useNavigate, useSearchParams } from 'react-router-dom';
import {
  Alert, Box, Button, Card, CardContent, TextField, Typography, Link,
} from '@mui/material';
import { Science as ScienceIcon } from '@mui/icons-material';
import { apiPost } from '../../services/api';
import usePageTitle from '../../hooks/usePageTitle';

export default function ResetPassword() {
  usePageTitle('Reset Password');
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const email = params.get('email') || '';
  const token = params.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setSubmitting(true);
    const result = await apiPost('/api/Account/reset-password', { email, token, newPassword: password });
    setSubmitting(false);
    if (result.ok) {
      setDone(true);
      setTimeout(() => navigate('/login'), 2500);
    } else {
      setError(result.error || 'Could not reset your password. The link may have expired.');
    }
  };

  const invalidLink = !email || !token;

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default' }}>
      <Card sx={{ width: '100%', maxWidth: 420, mx: 2 }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <ScienceIcon sx={{ fontSize: 48, color: 'primary.main', mb: 1 }} />
            <Typography variant="h5" fontWeight={700} color="primary.main">Choose a new password</Typography>
          </Box>

          {done ? (
            <Alert severity="success">Your password has been reset. Redirecting to sign in…</Alert>
          ) : invalidLink ? (
            <Alert severity="error">This reset link is invalid or incomplete. Please request a new one.</Alert>
          ) : (
            <Box component="form" onSubmit={handleSubmit}>
              {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
              <TextField
                label="New password" type="password" fullWidth required autoFocus
                value={password} onChange={(e) => setPassword(e.target.value)}
                sx={{ mb: 2 }}
              />
              <TextField
                label="Confirm new password" type="password" fullWidth required
                value={confirm} onChange={(e) => setConfirm(e.target.value)}
                sx={{ mb: 3 }}
              />
              <Button type="submit" variant="contained" fullWidth size="large" disabled={submitting}>
                {submitting ? 'Resetting...' : 'Reset password'}
              </Button>
            </Box>
          )}

          <Typography variant="body2" color="text.secondary" sx={{ mt: 2, textAlign: 'center' }}>
            <Link component={RouterLink} to="/login">Back to sign in</Link>
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
